import { useEffect, useState } from "react";
import HeaderDashboard from "../../components/HeaderDashboard"
import { useUser } from "../../../contexts/UserContext";
import FolderSharedIcon from '@mui/icons-material/FolderShared';
import { Breadcrumbs, Button, Link, Typography } from "@mui/material";
import axios from "axios";
import Loading from "../../components/Loading";
import AlertSuccess from "../../components/AlertSuccess";
import AlertError from "../../components/AlertError";
import { useNavigate } from "react-router-dom";
import HomeIcon from '@mui/icons-material/Home';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';

const Documentos = () => {


    const { user } = useUser();
    const navigate = useNavigate();

    const [documentos, setDocumentos] = useState({});


    const [userActive, setUserActive] = useState(true);
    const [openModalNotificacao, setOpenModalNotificacao] = useState(false);
    const [loading, setLoading] = useState(false);
    const [openSnackbarSuccess, setOpenSnackbarSuccess] = useState(false);
    const [openSnackbarError, setOpenSnackbarError] = useState(false);
    const [mensagem, setMensagem] = useState("");

    const [rgCnh, setRgCnh] = useState(null);
    const [tituloEleitor, setTituloEleitor] = useState(null);
    const [comprovanteResidencia, setComprovanteResidencia] = useState(null);


    const [dragOver, setDragOver] = useState(false);

    // const 

    // Função para lidar com o arquivo solto
    const handleDrop = (event) => {
        event.preventDefault();
        setDragOver(false);
        const droppedFile = event.dataTransfer.files[0];
        if (droppedFile) {
            setRgCnh(droppedFile);
        }
    };

    // Função para lidar com a seleção do arquivo via input
    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            setRgCnh(selectedFile);
        }
    };

    const handleTituloEleitorChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            setTituloEleitor(selectedFile);
        }
    };

    const handleComprovanteResidenciaChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            setComprovanteResidencia(selectedFile);
        }
    };

    // Prevenção do comportamento padrão para o evento de arraste
    const handleDragOver = (event) => {
        event.preventDefault();
        setDragOver(true);
    };

    const handleDragLeave = () => {
        setDragOver(false);
    };

    const handleSaveRgCnh = async () => {
        if (rgCnh) {
            setLoading(true);
            // Cria um FormData e adiciona o arquivo
            const formData = new FormData();
            formData.append("file", rgCnh); // 'file' é o campo que o backend espera
            formData.append('tipoDocumento', 'rgCnh');

            try {
                // Envia o arquivo para o backend usando Axios
                const response = await axios.post(`${process.env.REACT_APP_API_URL}/uploadDocumentacao`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data', // Importante para enviar arquivos
                        'Authorization': `${localStorage.getItem("token")}`, // Adiciona o token de autenticação se necessário
                    },
                });

                if (response.status === 200) {
                    getDocumentos();
                    setMensagem("Arquivo enviado com sucesso!");
                    setOpenSnackbarSuccess(true);
                    console.log("Arquivo enviado:", rgCnh);
                    // Limpa o arquivo após o envio, se necessário
                    setRgCnh(null);
                } else {
                    setMensagem("Erro ao enviar o arquivo.");
                    setOpenSnackbarError(true);
                }
            } catch (error) {
                console.error("Erro ao enviar o arquivo:", error);
                setMensagem("Erro ao enviar o arquivo.");
                setOpenSnackbarError(true);
            } finally {
                setLoading(false);
            }
        } else {
            setMensagem("Nenhum arquivo selecionado.");
            setOpenSnackbarError(true);
        }
    };

    const handleSaveTituloEleitor = async () => {
        if (tituloEleitor) {
            setLoading(true);
            // Cria um FormData e adiciona o arquivo
            const formData = new FormData();
            formData.append("file", tituloEleitor); // 'file' é o campo que o backend espera
            formData.append('tipoDocumento', 'tituloEleitor');

            try {
                // Envia o arquivo para o backend usando Axios
                const response = await axios.post(`${process.env.REACT_APP_API_URL}/uploadDocumentacao`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data', // Importante para enviar arquivos
                        'Authorization': `${localStorage.getItem("token")}`, // Adiciona o token de autenticação se necessário
                    },
                });

                if (response.status === 200) {
                    getDocumentos();
                    setMensagem("Arquivo enviado com sucesso!");
                    setOpenSnackbarSuccess(true);
                    console.log("Arquivo enviado:", rgCnh);
                    // Limpa o arquivo após o envio, se necessário
                    setRgCnh(null);
                } else {
                    setMensagem("Erro ao enviar o arquivo.");
                    setOpenSnackbarError(true);
                }
            } catch (error) {
                console.error("Erro ao enviar o arquivo:", error);
                setMensagem("Erro ao enviar o arquivo.");
                setOpenSnackbarError(true);
            } finally {
                setLoading(false);
            }
        }
    }


    const handleSaveComprovanteResidencia = async () => {
        if (comprovanteResidencia) {
            setLoading(true);
            // Cria um FormData e adiciona o arquivo
            const formData = new FormData();
            formData.append("file", comprovanteResidencia); // 'file' é o campo que o backend espera
            formData.append('tipoDocumento', 'comprovanteResidencia');

            try {
                // Envia o arquivo para o backend usando Axios
                const response = await axios.post(`${process.env.REACT_APP_API_URL}/uploadDocumentacao`, formData, {
                    headers: {
                        'Content-Type': 'multipart/form-data', // Importante para enviar arquivos
                        'Authorization': `${localStorage.getItem("token")}`, // Adiciona o token de autenticação se necessário
                    },
                });

                if (response.status === 200) {
                    getDocumentos();
                    setMensagem("Arquivo enviado com sucesso!");
                    setOpenSnackbarSuccess(true);
                    console.log("Arquivo enviado:", comprovanteResidencia);
                    // Limpa o arquivo após o envio, se necessário
                    setComprovanteResidencia(null);
                } else {
                    setMensagem("Erro ao enviar o arquivo.");
                    setOpenSnackbarError(true);
                }
            } catch (error) {
                console.error("Erro ao enviar o arquivo:", error);
                setMensagem("Erro ao enviar o arquivo.");
                setOpenSnackbarError(true);
            } finally {
                setLoading(false);
            }
        }
    }


    const getDocumentos = async () => {
        const response = await axios.get(`${process.env.REACT_APP_API_URL}/getDocumentos`, {
            headers: {
                'Authorization': `${localStorage.getItem("token")}`, // Adiciona o token de autenticação se necessário
            },
        });

        console.log("Documentos do usuário:", response.data);
        setDocumentos(response.data.documentos);
    }
    useEffect(() => {
        getDocumentos();
    }, []);


    return (
        <>
            <HeaderDashboard userActive={userActive} setOpenModalNotificacao={setOpenModalNotificacao} notificacoes={0} />
            <div style={{ marginTop: "60px", padding: "20px", minHeight: "100vh", marginBottom: "50px" }}>
                <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "20px", marginBottom: "20px" }}>
                    <div style={{ width: "80%" }}>
                        <Breadcrumbs aria-label="breadcrumb">
                            <Link
                                underline="hover"
                                sx={{ display: 'flex', alignItems: 'center', cursor: "pointer" }}
                                color="inherit"
                                onClick={() => navigate("../dashboard")}
                            >
                                <HomeIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Dashboard
                            </Link>
                            <Typography
                                sx={{ color: 'text.primary', display: 'flex', alignItems: 'center' }}
                            >
                                <InsertDriveFileIcon sx={{ mr: 0.5 }} fontSize="inherit" />
                                Documentos
                            </Typography>
                        </Breadcrumbs>
                    </div>
                </div>
                <div style={{ width: "100%", display: "flex", justifyContent: "center" }}>
                    <div style={{ width: window.innerWidth > 600 ? "80%" : "100%", backgroundColor: "#f9f9f9", padding: "30px", borderRadius: "8px" }}>
                        <div style={{ width: "100%" }}>
                            <h2 style={{ color: "black" }}>Ficha de documentação</h2>
                            <p>Envie os documentos necessários para completar seu cadastro.</p>
                        </div>
                        <div style={{ width: "100%", height: "fit-content", backgroundColor: "white", marginTop: "20px", paddingBottom: "20px", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
                            <div style={{ display: "flex", alignItems: "center", padding: "15px", backgroundColor: "#1eff8733", borderTopLeftRadius: "8px", borderTopRightRadius: "8px" }}>
                                <FolderSharedIcon style={{ fontSize: "35px", marginRight: "15px", color: "#1EFF86" }} />
                                <div>
                                    <h3 style={{ margin: 0, color: "black" }}>RG ou CNH</h3>
                                </div>
                            </div>

                            {documentos?.rgCnhStatus === "Em Análise" || documentos?.rgCnhStatus === "Aprovado" ? (
                                <div style={{ padding: "15px", textAlign: "center", borderRadius: "5px" }}>
                                    <span style={{ display: "block", fontSize: "16px", fontWeight: "bold", color: "#4caf50" }}>
                                        Arquivo enviado com sucesso
                                    </span>
                                    <span style={{ display: "block", fontSize: "14px", color: documentos?.rgCnhStatus === "Aprovado" ? "green" : "orange", marginTop: "5px" }} >
                                        {documentos.rgCnhStatus}
                                    </span>
                                </div>
                            ) : (
                                <div style={{ padding: "15px", textAlign: "center" }}>
                                    {documentos?.rgCnhStatus === "Reprovado" && (
                                        <>
                                            <p style={{ color: "red", fontWeight: "bold", margin: 10 }}>Seu documento foi rejeitado. Por favor, envie novamente.</p>
                                            <span>{documentos?.rgCnhMotivoRejeicao ? `Motivo: ${documentos.rgCnhMotivoRejeicao}` : ""}</span>
                                        </>
                                    )}

                                    <div
                                        style={{
                                            width: "100%",
                                            padding: "50px",
                                            border: "2px dashed #1EFF86",
                                            borderRadius: "8px",
                                            backgroundColor: dragOver ? "#f0f8f3" : "#fafafa",
                                            color: dragOver ? "#1EFF86" : "#aaa",
                                            cursor: "pointer",
                                        }}
                                        onDrop={handleDrop}
                                        onDragOver={handleDragOver}
                                        onDragLeave={handleDragLeave}
                                        onClick={() => document.getElementById('upload-rg-cnh').click()}
                                    >
                                        {rgCnh ? (
                                            <div style={{ width: "100%" }}>
                                                <p
                                                    style={{
                                                        marginBottom: "5px",
                                                        fontWeight: "bold",
                                                        fontSize: "14px",
                                                        whiteSpace: "nowrap",  // Impede a quebra de linha
                                                        overflow: "hidden",    // Oculta o texto que ultrapassar a largura
                                                        textOverflow: "ellipsis", // Adiciona "..." ao final
                                                        maxWidth: "100%"        // Garante que a largura seja limitada ao contêiner
                                                    }}
                                                >
                                                    Arquivo: {rgCnh.name}
                                                </p>
                                                <p style={{ fontSize: "12px", color: "#666" }}>
                                                    Clique ou arraste outro arquivo para substituir.
                                                </p>
                                            </div>
                                        ) : (
                                            <p>Arraste e solte o arquivo aqui ou clique para selecionar um arquivo.</p>
                                        )}

                                    </div>
                                    <input
                                        type="file"
                                        accept="image/*,application/pdf"
                                        style={{ display: "none" }}
                                        id="upload-rg-cnh"
                                        onChange={handleFileChange}
                                    />
                                    <div style={{ gap: "10px", display: "flex", justifyContent: "center" }}>
                                        <Button
                                            onClick={handleSaveRgCnh}
                                            style={{
                                                display: "inline-block",
                                                padding: "10px 20px",
                                                backgroundColor: "#1eff8733",
                                                color: "black",
                                                borderRadius: "5px",
                                                cursor: "pointer",
                                                marginTop: "10px",
                                                fontSize: "14px"
                                            }}>
                                            Enviar
                                        </Button>
                                    </div>
                                </div>
                            )}

                        </div>






                        <div style={{ width: "100%", height: "fit-content", backgroundColor: "white", marginTop: "20px", paddingBottom: "20px", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
                            <div style={{ display: "flex", alignItems: "center", padding: "15px", backgroundColor: "#1eff8733", borderTopLeftRadius: "8px", borderTopRightRadius: "8px" }}>
                                <FolderSharedIcon style={{ fontSize: "35px", marginRight: "15px", color: "#1EFF86" }} />
                                <div>
                                    <h3 style={{ margin: 0, color: "black" }}>Título de Eleitor</h3>
                                </div>
                            </div>

                            {documentos?.tituloEleitorStatus === "Em Análise" || documentos?.tituloEleitorStatus === "Aprovado" ? (
                                <div style={{ padding: "15px", textAlign: "center", borderRadius: "5px" }}>
                                    <span style={{ display: "block", fontSize: "16px", fontWeight: "bold", color: "#4caf50" }}>
                                        Arquivo enviado com sucesso
                                    </span>
                                    <span style={{ display: "block", fontSize: "14px", color: documentos?.tituloEleitorStatus === "Aprovado" ? "green" : "orange", marginTop: "5px" }} >
                                        {documentos.tituloEleitorStatus}
                                    </span>
                                </div>
                            ) : (
                                <div style={{ padding: "15px", textAlign: "center" }}>
                                    {documentos?.tituloEleitorStatus === "Reprovado" && (
                                        <>
                                            <p style={{ color: "red", fontWeight: "bold", margin: 10 }}>Seu documento foi rejeitado. Por favor, envie novamente.</p>
                                            <span>{documentos?.tituloEleitorMotivoRejeicao ? `Motivo: ${documentos.tituloEleitorMotivoRejeicao}` : ""}</span>
                                        </>
                                    )}
                                    <div
                                        style={{
                                            width: "100%",
                                            padding: "50px",
                                            border: "2px dashed #1EFF86",
                                            borderRadius: "8px",
                                            backgroundColor: dragOver ? "#f0f8f3" : "#fafafa",
                                            color: dragOver ? "#1EFF86" : "#aaa",
                                            cursor: "pointer",
                                        }}
                                        onDrop={handleDrop}
                                        onDragOver={handleDragOver}
                                        onDragLeave={handleDragLeave}
                                        onClick={() => document.getElementById('upload-titulo-eleitor').click()}

                                    >
                                        {tituloEleitor ? (
                                            <div>
                                                <p style={{ marginBottom: "5px", fontWeight: "bold" }}>Arquivo: {tituloEleitor.name}</p>
                                                <p style={{ fontSize: "12px", color: "#666" }}>Clique ou arraste outro arquivo para substituir.</p>
                                            </div>
                                        ) : (
                                            <p>Arraste e solte o arquivo aqui ou clique para selecionar um arquivo.</p>
                                        )}
                                    </div>
                                    <input
                                        type="file"
                                        accept="image/*,application/pdf"
                                        style={{ display: "none" }}
                                        id="upload-titulo-eleitor"
                                        onChange={handleTituloEleitorChange}
                                    />
                                    <div style={{ gap: "10px", display: "flex", justifyContent: "center" }}>
                                        <Button
                                            onClick={handleSaveTituloEleitor}
                                            style={{
                                                display: "inline-block",
                                                padding: "10px 20px",
                                                backgroundColor: "#1eff8733",
                                                color: "black",
                                                borderRadius: "5px",
                                                cursor: "pointer",
                                                marginTop: "10px",
                                                fontSize: "14px"
                                            }}>
                                            Enviar
                                        </Button>
                                    </div>
                                </div>
                            )}



                        </div>






                        <div style={{ width: "100%", height: "fit-content", backgroundColor: "white", marginTop: "20px", paddingBottom: "20px", borderRadius: "8px", boxShadow: "0 2px 4px rgba(0,0,0,0.1)" }}>
                            <div style={{ display: "flex", alignItems: "center", padding: "15px", backgroundColor: "#1eff8733", borderTopLeftRadius: "8px", borderTopRightRadius: "8px" }}>
                                <FolderSharedIcon style={{ fontSize: "35px", marginRight: "15px", color: "#1EFF86" }} />
                                <div>
                                    <h3 style={{ margin: 0, color: "black" }}>Comprovante de Residência</h3>
                                </div>
                            </div>

                            {documentos?.comprovanteResidenciaStatus === "Em Análise" || documentos?.comprovanteResidenciaStatus === "Aprovado" ? (
                                <div style={{ padding: "15px", textAlign: "center", borderRadius: "5px" }}>
                                    <span style={{ display: "block", fontSize: "16px", fontWeight: "bold", color: "#4caf50" }}>
                                        Arquivo enviado com sucesso
                                    </span>
                                    <span style={{ display: "block", fontSize: "14px", color: documentos?.comprovanteResidenciaStatus === "Aprovado" ? "green" : "orange", marginTop: "5px" }} >
                                        {documentos.comprovanteResidenciaStatus}
                                    </span>
                                </div>
                            ) : (

                                <div style={{ padding: "15px", textAlign: "center" }}>
                                    {documentos?.comprovanteResidenciaStatus === "Reprovado" && (
                                        <>
                                            <p style={{ color: "red", fontWeight: "bold", margin: 10 }}>Seu documento foi rejeitado. Por favor, envie novamente.</p>
                                            <span>{documentos?.comprovanteResidenciaMotivoRejeicao ? `Motivo: ${documentos.comprovanteResidenciaMotivoRejeicao}` : ""}</span>
                                        </>
                                    )}
                                    <div
                                        style={{
                                            width: "100%",
                                            padding: "50px",
                                            border: "2px dashed #1EFF86",
                                            borderRadius: "8px",
                                            backgroundColor: dragOver ? "#f0f8f3" : "#fafafa",
                                            color: dragOver ? "#1EFF86" : "#aaa",
                                            cursor: "pointer",
                                        }}
                                        onDrop={handleDrop}
                                        onDragOver={handleDragOver}
                                        onDragLeave={handleDragLeave}
                                        onClick={() => document.getElementById('upload-comprovante-residencia').click()}

                                    >
                                        {comprovanteResidencia ? (
                                            <div>
                                                <p style={{ marginBottom: "5px", fontWeight: "bold" }}>Arquivo: {comprovanteResidencia.name}</p>
                                                <p style={{ fontSize: "12px", color: "#666" }}>Clique ou arraste outro arquivo para substituir.</p>
                                            </div>
                                        ) : (
                                            <p>Arraste e solte o arquivo aqui ou clique para selecionar um arquivo.</p>
                                        )}
                                    </div>
                                    <input
                                        type="file"
                                        accept="image/*,application/pdf"
                                        style={{ display: "none" }}
                                        id="upload-comprovante-residencia"
                                        onChange={handleComprovanteResidenciaChange}
                                    />
                                    <div style={{ gap: "10px", display: "flex", justifyContent: "center" }}>
                                        <Button
                                            onClick={handleSaveComprovanteResidencia}
                                            style={{
                                                display: "inline-block",
                                                padding: "10px 20px",
                                                backgroundColor: "#1eff8733",
                                                color: "black",
                                                borderRadius: "5px",
                                                cursor: "pointer",
                                                marginTop: "10px",
                                                fontSize: "14px"
                                            }}>
                                            Enviar
                                        </Button>
                                    </div>
                                </div>
                            )}


                        </div>
                    </div>
                </div>
            </div >
            <Loading open={loading} />
            <AlertSuccess openSnackbarSuccess={openSnackbarSuccess} setOpenSnackbarSuccess={setOpenSnackbarSuccess} mensagem={mensagem} />
            <AlertError openSnackbarError={openSnackbarError} setOpenSnackbarError={setOpenSnackbarError} mensagem={mensagem} />
        </>
    )
}

export default Documentos